import create from 'zustand';
import createStoreSelectors from '../utils/createStoreSelector';

const useStore = create((set) => ({
  showSummary: false,
  finishSummary: {},
  toggleShowSummary: () => {
    set((state) => ({
      ...state,
      showSummary: !state.showSummary
    }));
  },
  setFinishSummary: (data) => {
    set((state) => ({
      ...state,
      finishSummary: data
    }));
  },
  clearData: () => {
    set((state) => ({
      ...state,
      showSummary: false,
      finishSummary: {}
    }));
  }
}));

const useFinishSummary = createStoreSelectors(useStore);

export default useFinishSummary;
